import noop from 'lodash/noop';
import { readable } from 'svelte/store';

import { getAirports } from 'src/api';

export const Airports = readable([], (set) => {
  getAirports().then(({ data }) => set(data));
  return noop;
});
